import { Routes } from '@angular/router';
import { authGuard } from './core/auth.guard';
import { LoginComponent } from './components/login/login.component';
import { AccountsManagerComponent } from './components/accounts-manager/accounts-manager.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'admin',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        component: AccountsManagerComponent
      }
    ]
  },{
    path: 'test/customer-form',
    loadComponent: () =>
      import('./features/customer-management/customer-form/customer-form.component').then(m => m.CustomerFormComponent)
  },

  {
    path: 'test/question-wizard',
    loadComponent: () =>
      import('./features/customer-management/question-wizard/question-wizard.component').then(m => m.QuestionWizardComponent)
  },{
    path: 'aggiungi-domande/:id',
    loadComponent: () =>
      import('./features/customer-management/question-wizard/question-wizard.component').then(
        m => m.QuestionWizardComponent
      )
  },

  {
    path: '**',
    redirectTo: 'login'
  }
];
